import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "form", "tab", "searchTextInput", "referralsDropzone", "tabName", "removeBtn", "loadingIcon" ]

  connect() {
    // Hide the spinner as soon as the search request finishes (success or
    // failure) rather than relying on the results frame reconnecting.
    this.formTarget.addEventListener('turbo:submit-end', () => this.hideLoading())
  }

  search(event) {
    setTimeout(() => {
      if (this.searchTextInputTarget.value.length >= 2) {
        this.formTarget.requestSubmit()
        this.removeBtnTarget.classList.remove('d-none')
        this.loadingIconTarget.classList.remove('d-none')
      } else {
        this.removeBtnTarget.classList.add('d-none')
        this.hideLoading()
        this.hideDropzone()
      }
    }, 200)
  }

  hideLoading() {
    this.loadingIconTarget.classList.add('d-none')
  }

  handleClickReferralTab(event) {
    // Handle check dropdown item when clicking
    event.target.closest('.referral-tabs-dropdown').querySelectorAll('.tab-item').forEach((tab) => {
      tab.classList.remove('active')
    });
    event.target.closest('.tab-item').classList.add('active')
    // Set the tab value and tab name
    this.tabTarget.value = event.target.closest('.tab-item').dataset.tabKey
    this.tabNameTarget.innerText = event.target.closest('.tab-item').dataset.tabName
    this.searchTextInputTarget.focus()
    if (this.searchTextInputTarget.value.length >= 2) {
      this.formTarget.requestSubmit()
    }
  }

  handleFocusOutInput(event) {
    const dropzone = document.querySelector('.referrals-dropzone') || document.querySelector('.mobile-search-results');
    if (dropzone && dropzone.contains(event.relatedTarget)) {
      return;
    }

    setTimeout(() => {
      this.hideDropzone()
      this.hideLoading()
    }, 200)
  }

  resetInputValue() {
    this.searchTextInputTarget.value = ""
    this.removeBtnTarget.classList.add('d-none')
    this.hideDropzone()
  }

  hideDropzone() {
    const dropzone = document.querySelector('.referrals-dropzone') || document.querySelector('.mobile-search-results');
    if (dropzone) {
      dropzone.classList.add("d-none");
    }
  }

  referralsDropzoneTargetConnected(e) {
    this.hideLoading()
  }
}